import { RepeatIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';

interface RefreshButtonProps {
  isRefreshing: boolean;
  onRefresh: () => void;
  testId: string;
}

/** Reloads what a reconciliation page shows, without reloading the browser page. */
function RefreshButton({ isRefreshing, onRefresh, testId }: RefreshButtonProps) {
  return (
    <Button
      leftIcon={<RepeatIcon boxSize="16px" />}
      size="sm"
      variant="outline"
      flexShrink={0}
      isLoading={isRefreshing}
      onClick={onRefresh}
      data-testid={testId}
    >
      Refresh
    </Button>
  );
}

export default RefreshButton;
